import React, { useRef } from "react";
import s from "./Contact.module.css";
import { CiLocationOn } from "react-icons/ci";
import { IoIosMail } from "react-icons/io";
import { MdLocalPhone } from "react-icons/md";
import { FaLinkedinIn } from "react-icons/fa";
import emailjs from "@emailjs/browser";

const Contact = () => {
  const formRef = useRef();

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_vknou4v", // Replace with your EmailJS service ID
        "template_h7zsq3r", // Replace with your EmailJS template ID
        formRef.current,
        "V3_sgwa5cxXOFptlN" // Replace with your EmailJS public key
      )
      .then(
        (result) => {
          console.log(
            "Mesajınız başarıyla gönderildi! En kısa sürede dönüş yapılcaktır.",
            result.text
          );
          alert(
            "Mesajınız başarıyla gönderildi! En kısa sürede dönüş yapılcaktır."
          );
        },
        (error) => {
          console.error("Error sending email:", error.text);
          alert(
            "Mesajınızı gönderirken bir sorun oluştu. Lüften tekrar deneyin."
          );
        }
      );
  };
  return (
    <div id="contact_form" className={s.main_container}>
      <div className={s.content}>
        <div className={s.left_container}>
          <h3 className={s.left_title}>İletişime Geçin</h3>
          <span className={s.left_desc}>
            Sorularınız, işbirliği teklifleri veya herhangi bir konuda iletişim
            kurmak isterseniz, formu doldurabilirsiniz.
          </span>
          <div className={s.left_box}>
            <div className={s.box_image}>
              <CiLocationOn size={20} color="#fff" />
            </div>

            <div className={s.box_data}>
              <h6>Adres:</h6>
              <span> Odunpazarı/Eskişehir</span>
            </div>
          </div>
          <div className={s.left_box}>
            <div className={s.box_image}>
              <IoIosMail size={20} color="#fff" />
            </div>
            <div className={s.box_data}>
              <h6>E-Mail:</h6>
              <span>nazif.gungor@avideftr.com</span>
            </div>
          </div>
          <div className={s.left_box}>
            <div className={s.box_image}>
              <MdLocalPhone size={20} color="#fff" />
            </div>
            <div className={s.box_data}>
              <h6>Telefon Numarası</h6>
              <span>+90 530 543 44 76</span>
            </div>
          </div>
          <div className={s.social_icon}>
            <a
              href="https://www.linkedin.com/in/nazif-g%C3%BCng%C3%B6r-25095a239/"
              target="_blank"
              rel="noopener noreferrer" // Güvenlik için rel özelliği
              style={{ textDecoration: "none" }} // Varsayılan alt çizgiyi kaldırmak için
            >
              <FaLinkedinIn
                style={{ cursor: "pointer" }}
                size={36}
                color="#fff"
              />
            </a>
          </div>
        </div>

        <div className={s.right_container}>
          <form ref={formRef} className={s.form} onSubmit={handleSubmit}>
            <div className={s.form_group}>
              <label htmlFor="name">Ad Soyad</label>
              <input
                type="text"
                id="name"
                name="user_name"
                placeholder="Adınızı Giriniz"
                className={s.input}
                required
              />
            </div>
            <div className={s.form_group}>
              <label htmlFor="email">E-Mail</label>
              <input
                type="email"
                id="email"
                name="user_email"
                placeholder="E-Mail Adresinizi Giriniz"
                className={s.input}
                required
              />
            </div>
            <div className={s.form_group}>
              <label htmlFor="subject">Konu</label>
              <input
                type="text"
                id="subject"
                name="subject"
                placeholder="Konu Başlığı Giriniz"
                className={s.input}
                required
              />
            </div>
            <div className={s.form_group}>
              <label htmlFor="message">Mesaj</label>
              <textarea
                id="message"
                name="message"
                placeholder="Mesajınızı Yazınız"
                className={s.textarea}
                required
              />
            </div>
            <button type="submit" className={s.submit_button}>
              Gönder
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
